// extracted by mini-css-extract-plugin
export var menuIcon = "_qh-0";
export var menuIconInline = "_qh-1";